/*
 * Image capture: `capture_image` over the data channel, at most one per CAPTURE_COOLDOWN_MS. The server stores the frame and orc answers on the user channel with `image_status`; the id is expected in `ownMedia` so only this client brings Images forward.
 */
import { v4 as uuid } from 'uuid'
import { DC_MESSAGES } from './constants'
import { expectMedia } from './ownMedia'

export const CAPTURE_COOLDOWN_MS = 1000

const sentListeners = new Set()
let lastAt = -Infinity

export function captureImage(socket) {
	const now = performance.now()
	if (now - lastAt < CAPTURE_COOLDOWN_MS) return false
	lastAt = now
	const id = uuid()
	expectMedia('images', id)
	socket.sendDC(DC_MESSAGES.CAPTURE_IMAGE, { image_id: id })
	for (const fn of sentListeners) fn(id)
	return true
}

/** Every accepted capture of this client; returns the unsubscribe. */
export function onCaptureSent(fn) {
	sentListeners.add(fn)
	return () => sentListeners.delete(fn)
}
